import React, { useState } from 'react';
import { message } from 'antd';
import DefaultForm from 'components/form/DefaultForm';
import DefaultModal from 'components/modal/DefaultModal';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import UploadImage from './UploadImage';
import { backgroundApi } from 'apis/resource/backgroundApis';
import { handleMessage } from 'utils/helper/message';
import PrimaryButton from 'components/button/PrimaryButton';
import InputStyled from 'components/InputStyled';
import { IStaticImage } from 'utils/types/storyTypes';
/**
 * * 리소스 - 배경 수정 모달
 */

interface IProps {
  visible: boolean;
  setVisible: (e: any) => void;
  selectedData: IStaticImage | undefined;
  setSelectedData: React.Dispatch<
    React.SetStateAction<IStaticImage | undefined>
  >;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  refresh: boolean;
}

const BackgroundUpdateModal = ({
  visible,
  setVisible,
  selectedData,
  setSelectedData,
  setRefresh,
  refresh,
}: IProps) => {
  const { t } = useTranslation();

  const handleClose = () => {
    console.log(`handleClose, `, selectedData);
    setVisible(false);
  };
  const [loading, setLoading] = useState<boolean>(false);
  /// 서버 전송
  const handleSubmit = async () => {
    if (selectedData) {
      const postData = {
        update: selectedData,
      };
      try {
        setLoading(true);
        await backgroundApi.backgroundUpdateInfo(
          selectedData.project_id,
          selectedData.id,
          postData,
        );
        setRefresh(!refresh);
        setVisible(false);
        setLoading(false);
        handleMessage(message, 'success', 'Success');
      } catch (err) {
        console.log('update error', err);
        setLoading(false);
        handleMessage(message, 'error', 'Error');
      }
    }
  };

  // * input 입력
  const handleInputChange = (e, type: string) => {
    // console.log(e.target.value);

    if (selectedData) {
      // selectedData.game_scale = newScale;
      setSelectedData((current) => {
        if (current) {
          const cloneData = structuredClone(current);

          if (type == 'game_scale') {
            cloneData.game_scale = e.target.value;

            if (!isNaN(cloneData.game_scale) && cloneData.game_scale > 2)
              cloneData.game_scale = 2;
          } else if (type == 'image_name')
            cloneData.image_name = e.target.value;

          return cloneData;
        } else return current;
      });
    }
  };
  return (
    <DefaultModal
      title={t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.backgroundContent.editBackgroundModal.title',
      )}
      visible={visible}
      onCancel={handleClose}
      footer={
        <ButtonWrapper>
          <PrimaryButton
            text={t('updateStory.form.buttonSubmit')}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
            loading={loading}
          />
        </ButtonWrapper>
      }
    >
      <DefaultForm>
        <HeaderWrapper>
          <p>ID: {selectedData?.id}</p>
        </HeaderWrapper>
        <FormWrapper>
          <div>
            <p className='title'>
              {t(
                'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.backgroundContent.editBackgroundModal.backgroundNameID',
              )}
            </p>
            <InputStyled
              value={selectedData?.image_name}
              onChange={(e) => {
                handleInputChange(e, 'image_name');
              }}
              maxLength={30}
            />
            <p className='length-subtext'>
              {typeof selectedData?.image_name?.length === 'number'
                ? `${selectedData?.image_name?.length}/30 characters`
                : '0/30 characters'}
            </p>
          </div>
          <div>
            <p className='title'>
              {t(
                'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.backgroundContent.editBackgroundModal.gameScale',
              )}
            </p>
            <InputStyled
              value={selectedData?.game_scale}
              onChange={(e) => {
                handleInputChange(e, 'game_scale');
              }}
              maxLength={30}
              type='number'
              step='0.01'
            />
            <p className='title'>
              * 게임내에서 보여지는 이미지의 크기 비율입니다(최대값 : 2)
            </p>
          </div>
          <UploadImage
            data={selectedData}
            setData={setSelectedData}
            hideRequired={true}
          />
        </FormWrapper>
      </DefaultForm>
    </DefaultModal>
  );
};

export default BackgroundUpdateModal;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  p {
    color: ${theme.colors.dark_500};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.md};
  }
`;

const FormWrapper = styled.div`
  & > * + * {
    margin-top: 16px;
  }
  .title,
  .length-subtext {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  .length-subtext {
    margin-top: 8px !important;
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_200};
  }
  .ant-input-show-count-suffix {
    display: none;
  }
  .remove {
    display: flex;
    justify-content: end;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;
